import { Text, useProgress } from '@react-three/drei';
import { useFrame, useThree } from '@react-three/fiber';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as THREE from 'three';

export const Loader = () => {
  const { t } = useTranslation('components');
  const { progress } = useProgress();
  const { camera } = useThree();
  const ref = useRef<THREE.Object3D | null>(null);

  useFrame(() => {
    if (!ref.current) return;
    // attach to camera
    ref.current.position.copy(camera.position);
    ref.current.quaternion.copy(camera.quaternion);
    // move 2 units in front of the camera
    ref.current.translateZ(-0.5);
  });

  return (
    <group ref={ref}>
      <Text fontSize={0.012} color='white' anchorX='center' anchorY='middle'>
        {t('loader.loading')}
      </Text>
    </group>
  );
};
